module.exports = __webpack_public_path__ + "img/awards-winner.b167997.png";